<template>
  <div>
    <h2 class="text-lg font-semibold text-white mb-4">{{ t('share_mission.title') }}</h2>

    <!-- Copy Link -->
    <div class="mb-6">
      <p class="text-gray-300 mb-2 text-sm">{{ t('share_mission.copy_link_description') }}</p>
      <b-copy-link :link="joinLink" />
    </div>

    <!-- Social Share -->
    <div>
      <p class="text-gray-300 mb-2 text-sm">{{ t('share_mission.social_share_description') }}</p>
      <div class="flex flex-wrap gap-2 sm:gap-4">
        <b-button variant="primary" light prepend-icon="mdi:linkedin" @click="openLink(linkedinLink)" class="flex-1 min-w-[100px]">
          LinkedIn
        </b-button>
        <b-button variant="primary" light prepend-icon="mdi:slack" @click="openLink(slackLink)" class="flex-1 min-w-[100px]">
          Slack
        </b-button>
        <b-button variant="primary" light prepend-icon="mdi:whatsapp" @click="openLink(whatsappLink)" class="flex-1 min-w-[100px]">
          WhatsApp
        </b-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import BCopyLink from '~/components/forms/BCopyLink.vue';
import BButton from '~/components/forms/BButton.vue';
import type { Mission, MissionResponse } from "~/api/v2/missions/MissionRepository";

const { t } = useI18n();
const config = useRuntimeConfig();

const props = defineProps<{
  mission: Mission | MissionResponse | null
}>();

const joinLink = computed(() => props.mission ? `${config.public.NUXT_APP_URL}pass-d/${props.mission.id}/join` : '');
const encodedUrl = computed(() => encodeURIComponent(joinLink.value));
const shareMessage = computed(() => {
  const mission = props.mission as (Mission & MissionResponse) | null;
  return t('share_mission.share_message', { missionName: mission?.name || mission?.title });
});
const encodedShareMessage = computed(() => encodeURIComponent(shareMessage.value));

const linkedinLink = computed(() => `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl.value}`);
const slackLink = computed(() => `https://app.slack.com/search?q=${encodedShareMessage.value}`);
const whatsappLink = computed(() => `https://wa.me/?text=${encodedShareMessage.value}%20${encodedUrl.value}`);

const openLink = (url: string) => {
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};
</script>
